import { Component, ViewChild } from '@angular/core';
import { NavbarService } from '../navbar/navbar.service';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';
import { HttpParams } from '@angular/common/http';
import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.css'],
})
export class NotificacionesComponent {
  constructor(
    private readonly auth: AuthLoginService,
    private readonly router: Router,
    private readonly notificaciones: NavbarService
  ) {}

  params = new HttpParams();

  async ngOnInit() {
    const userState = await this.auth.returnUserInfoV2('PARTIAL');

    if (!userState) {
      return;
    }

    this.params = this.params.set('usuario', userState.user.id);
    this.params = this.params.set('page', 1);
    this.params = this.params.set('perPage', 10);
    this.params = this.params.set('sortBy', 'DESC');

    this.getHistoric();
  }

  getHistoric() {
    this.notificaciones.getNotificaciones(this.params).subscribe((data) => {
      this.forms = data.entities;
      this.totalRecords = data.count;
    });
  }

  forms: any[] = [];

  totalRecords = 0;

  @ViewChild('table') table!: Table;
  @ViewChild('paginator') Paginator!: Paginator;

  first: number = 0;

  rows: number = 10;

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.params = this.params.set('page', event.page + 1);
    this.params = this.params.set('perPage', event.rows);
    this.getHistoric();
  }

  onRowSelect(link: string) {
    this.router.navigate([link]);
  }

  onSort(ev: any) {
    switch (ev.order) {
      case 1: {
        if (this.params.get('sortBy') !== 'ASC') {
          this.params = this.params.set('sortBy', 'ASC');
          this.getHistoric();
        }
        break;
      }
      case -1: {
        if (this.params.get('sortBy') !== 'DESC') {
          this.params = this.params.set('sortBy', 'DESC');
          this.getHistoric();
        }
        break;
      }
    }
  }
}
